import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { satisfied, unhappy, neutral, done, notification } from "../images";

const satisfactionLevels = {
    unhappy: {
        name: 'unhappy',
        image: unhappy,
        message: 'We are sorry, What did we do wrong?',
    },
    neutral: {
        name: 'neutral',
        image: neutral,
        message: 'Confusing? Why is that?',
    },
    satisfied: {
        name: 'satisfied',
        image: satisfied,
        message: 'What makes you satisfied?',
    },
}

const FeatureRatingsModal = ({ background, feature, isAlert = true, hideModal, submitFeatureRatings }) => {
    const history = useHistory();
    const onOkClick = () => {
        switch (feature) {
            case 'Movie Mania':
                history.push('/loyalty/moviemania');
                break;
            case 'Trivia':
                history.push('/trivia');
                break;
        }
        hideModal();
    }

    const submitFeedback = (data) => {
        submitFeatureRatings(data);
    }

    return (
        <ModalHolder>
            <div style={{
                background: '#fff',
                position: 'relative',
                padding: '30px',
                maxWidth: '480px',
                width: '90%',
                boxSizing: 'border-box',
                textAlign: 'center',
                borderRadius: '15px',
                fontFamily: 'MTNRegular'
            }}>
                {
                    isAlert ?
                        <FeatureAlert feature={feature} onOkClick={onOkClick} onCancelClick={hideModal} background={background} /> :
                        <FeatureFeedback feature={feature} onOkClick={submitFeedback} onCancelClick={hideModal} background={background} />
                }
            </div>
        </ModalHolder>
    )
}

const ModalHolder = ({ children }) => {
    return <div style={{
        position: 'absolute',
        zIndex: 100,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.7)'
    }}>
        <div style={{
            boxSizing: 'border-box',
            padding: '20px',
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            {children}
        </div>
    </div>
}

const FeatureAlert = ({ feature = '', onCancelClick, onOkClick, background }) => {
    const text = `Check out the new ${feature} feature!`
    return (
        <div>
            <div><img src={notification} /></div>
            <div style={{ margin: '25px 0' }}>{text}</div>
            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                <Button onClick={onCancelClick} bgColor="#fff" textColor={background} borderColor={background}>Not now</Button>
                <Button onClick={onOkClick} bgColor={background} textColor="#fff" borderColor={background}>Go</Button>
            </div>
        </div>
    )
}

const FeatureFeedback = ({ feature = '', onCancelClick, onOkClick, background }) => {
    const [experience, setExperience] = useState();
    const [feedbackMessage, setFeedbackMessage] = useState();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [page, setPage] = useState(1);
    const text = `Rate your experience with ${feature}`
    const handleExperienceClick = (experience) => {
        setPage(2);
        setExperience(experience);
    }
    const handleSubmission = () => {
        onOkClick({
            feature,
            feedbackExperience: experience.name,
            feedbackMessage
        });
        setIsSubmitted(true);
    }
    return (
        <div>
            {
                isSubmitted ?
                    <div>
                        <img src={done} />
                        <div style={{ margin: '25px 0', fontSize: '18px', fontFamily: 'MTNBold' }}>Thank you for your help!</div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                            <Button onClick={onCancelClick} bgColor={background} textColor={'#fff'} borderColor={background}>Close</Button>
                        </div>

                    </div> :
                    <>
                        {page === 2 && <p onClick={() => setPage(1)} style={{
                            position: 'absolute',
                            cursor: 'pointer',
                            margin: 0,
                            left: '0px',
                            top: '0px',
                            padding: '20px',
                            fontSize: '23px',
                        }}>&#x2190;</p>}
                        {
                            page === 1 ?
                                <>
                                    <div style={{ marginBottom: '25px' }}>{text}</div>
                                    <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginBottom: '25px' }}>
                                        <IconButton experience={satisfactionLevels.unhappy} onClick={handleExperienceClick} />
                                        <IconButton experience={satisfactionLevels.neutral} onClick={handleExperienceClick} />
                                        <IconButton experience={satisfactionLevels.satisfied} onClick={handleExperienceClick} />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                                        <Button onClick={onCancelClick} bgColor="#fff" textColor={'#C8CBCB'} borderColor={'#fff'}>Not now</Button>
                                    </div>
                                </> :
                                <div>
                                    <IconButton experience={experience} showMessage />
                                    <Textarea onChange={e => setFeedbackMessage(e.target.value)} value={feedbackMessage} placeholder="What else do you like?  Would you improve anything? [Optional]"></Textarea>
                                    <Button onClick={handleSubmission} bgColor={background} textColor="#fff" borderColor={background}>Submit</Button>
                                </div>
                        }
                    </>
            }
        </div>
    )
}

const IconButton = ({ experience, showMessage, onClick = () => { } }) => {
    const { image, name, message } = experience;
    return <div onClick={() => onClick(experience)}>
        <img src={image} style={{ width: '45px' }} />
        <div style={{ fontSize: '14px' }}>{showMessage ? message : name}</div>
    </div>
}

const Button = styled.button`
    border-radius: 20px;
    border: ${({ borderColor }) => `2px solid ${borderColor}`};
    background-color: ${({ bgColor }) => `${bgColor}`};
    color: ${({ textColor }) => `${textColor}`};
    padding: 5px 10px;
    width: 100px;
    box-sizing: border-box;
    font-size: 14px;
`;

const Textarea = styled.textarea`
    margin: 20px 0;
    padding: 10px;
    font-size: 13px;
    height: 100px;
    box-sizing: border-box;
    width: 100%;
    border-radius: 10px;
    border: 1px solid #ddd;
`;

export default FeatureRatingsModal;